import { MatDialog } from '@angular/material/dialog';
import { ModalAssignatureComponent } from './../modal-assignature/modal-assignature.component';
import { ProviderAssignmentService } from 'src/app/services/operacao/provider-assignment.service';
import { EscalaService } from './../../../services/operacao/escala.service';
import { SwalUtil } from 'src/app/services/utils/swal.util';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/vos/auth.service';
import { ReportsService } from 'src/app/services/vos/reports.service';
import Swal from 'sweetalert2';
import { AtribuicoesService } from 'src/app/services/rh/atribuicoes.service';

@Component({
  selector: 'app-formulario-relatorio',
  templateUrl: './formulario-relatorio.component.html',
  styleUrls: ['./formulario-relatorio.component.css']
})
export class FormularioRelatorioComponent implements OnInit {
  formulario!: FormGroup;
  arrayPaciente: Array<any> = []
  pacientesByPrestador: any = []
  usuario: any = [];
  salvando: boolean = false;
  inscricao: Subscription
  loading:boolean = true;
  patient: any = [];
  cardPatient: boolean = false;
  days: any[];
  days_forecast: any;
  loadingPatient: boolean = false;
  loadingServiceDate: boolean = false;
  data: any = [];

  // servicos
  loadingServices: boolean = false;
  services: any = [];
  servicesPackage: any = [];
  servicesPackageCustom: any = [];
  servico_id: any;
  prestador_id: any;
  assinatura: any;
  constructor(
    private router: Router,
    private reportsService: ReportsService,
    private authService: AuthService,
    private formbuilder: FormBuilder,
    private swalUtil: SwalUtil,
    private route: ActivatedRoute,
    private escalaService: EscalaService,
    private dialog: MatDialog,
    private providerassignmentService: ProviderAssignmentService,
    private atribuicoesService: AtribuicoesService
  ) { }

  ngOnInit(): void {
    let error = false;
    this.PegaUsuario()
    this.initForm().then(() => {
      this.loading = false;
      error = false;
    }).catch(() => {
      error = true;
      this.loading = false;
      this.swalUtil.popupMessage('Ocorreu um erro ao gerar o formulário!', 'error');
    })
    this.getPacientesByPrestador()
    this.inscricao = this.route.params.subscribe(params => {
      this.initForm();
      if (params.hasOwnProperty('id')) {
        this.inscricao = this.reportsService.findReport(params['id']).subscribe(data => {
          this.initForm(data);
          this.sendServiceForecast(data.ml_service_forecast);
          this.getPatient(data.patient)
        });
      }
    });
    //
  }

  get isNotProfessionalForHH() {
    if (!this.usuario.user.pessoa.profissional) return true;

    return this.usuario.user.pessoa.profissional.empresa_id != 42;
  }

  async initForm(data?) {
    this.formulario = await this.formbuilder.group({
      id:                         [data ? data.id                         : null],
      empresa_id:                 [data ? data.empresa_id                 : null],
      paciente_id:                [data ? data.patient                    : null, Validators.required],
      contract_id:                [data ? data.contract_id                : null],
      ordemservico_id:            [data ? data.ordemservico_id            : null],
      servico_id:                 [data ? data.servico_id                 : null],
      prestador_id:               [data ? data.prestador_id               : this.usuario.user.pessoa.prestador.id],
      historico_clinico:          [data ? data.historico_clinico          : ""],
      plano_terapeutico:          [data ? data.plano_terapeutico          : ""],
      objetivo:                   [data ? data.objetivo                   : ""],
      historico:                  [data ? data.historico                  : ""],
      dispositivo:                [data ? data.dispositivo                : ""],
      quadro_respiratorio:        [data ? data.quadro_respiratorio        : ""],
      assinatura:                 [data ? data.assinatura                 : "", Validators.required],
      quadro_motor:               [data ? data.quadro_motor               : ""],
      metas_terapeuticas:         [data ? data.metas_terapeuticas         : "", Validators.required],
      pa:                         [data ? data.pa                         : ""],
      p:                          [data ? data.p                          : ""],
      t:                          [data ? data.t                          : ""],
      fr:                         [data ? data.fr                         : ""],
      sat:                        [data ? data.sat                        : ""],
      ano:                        [data ? data.ano                        : "", Validators.required],
      mes:                        [data ? data.mes                        : "", Validators.required],
      ml_service_forecast:        [data ? data.ml_service_forecast        : []],
      inclusion_diagnosis:        [data ? data.inclusion_diagnosis        : ""],
      month_evolution:            [data ? data.month_evolution            : "", Validators.required],
      hospitalization_summary:    [data ? data.hospitalization_summary    : ""],
      equipments:                 [data ? data.equipments                 : ""],
      systems:                    [data ? data.systems                    : ""],
      guidelines_conduct:         [data ? data.guidelines_conduct         : "", Validators.required],
      justifications:             [data ? data.justifications             : "", Validators.required],
      general_report:             [data ? data.general_report             : ""],
    })

    if(data) {
      this.filterScales();
    }
  }

  sendServiceForecast(service_forecast: any) {
    this.days_forecast = service_forecast;
  }

  getPatient(patient){
    if(patient){
      this.patient = patient;
      this.formulario.patchValue(
        {
          contract_id: patient.contract_id,
          ordemservico_id: patient.ordemservico_id,
          empresa_id: patient.company_id,
          servico_id: patient.servico_id,
        }
      );
      this.getServices(patient);
      this.cardPatient = true;
    }
    else{
      this.cardPatient = false;
      this.formulario.patchValue(
        {
          contract_id: null,
          ordemservico_id: null,
          empresa_id: null,
          servico_id: null,
        }
      );
      this.services = null;
    }
  }

  PegaUsuario() {
    this.usuario = JSON.parse(this.authService.getUserLoggedIn());
  }

  getPacientesByPrestador() {
    let a = [];
    this.loadingPatient = true;
    this.inscricao = this.atribuicoesService.pacientesatribuidosaoprofissionalNew(this.usuario.user.pessoa.prestador.id).subscribe({
      next: res => {
        this.data = res;
        for (let i = 0; i < res.length; i++) {
          a.push({
            label: res[i].contract_id ? `${res[i].contract?.paciente?.pessoa?.nome}` : `${res[i].ordemservico?.orcamento?.homecare?.paciente?.pessoa?.nome}`,
            nasc: res[i].contract_id ? `${res[i].contract?.paciente?.pessoa?.nascimento}` : `${res[i].ordemservico?.orcamento?.homecare?.paciente?.pessoa?.nascimento}`,
            client: res[i].contract_id ? `${res[i].contract?.cliente?.pessoa?.nome}` : `${res[i].ordemservico?.orcamento?.cliente?.pessoa?.nome}`,
            patient_id: res[i].contract_id ? res[i].contract?.paciente_id : res[i].ordemservico?.orcamento?.homecare?.paciente_id,
            contract_id: res[i].contract_id,
            ordemservico_id: res[i].ordemservico_id,
            company_id: res[i].contract_id ? res[i].contract?.company_id : res[i].ordemservico?.empresa_id,
            servico_id: res[i].servico_id,
            servico_name: `${res[i].servico.descricao}`
          });
        }
        this.pacientesByPrestador = a.filter((patient) => patient.contract_id);
        this.loadingPatient = false;
      },
      error: err => {
        Swal.fire('', 'Houve um erro ao buscar pacientes.', 'error');
        this.loadingPatient = false;
      },
    })
  }

  salvarReports() {
    this.salvando = true;
    this.inscricao = this.reportsService.save(this.formulario.value).subscribe({
      next: () => {
        this.swalUtil.popupMessage('Relatório salvo com sucesso!', 'success');
        this.router.navigate(['/main/home']);
      },
      error: err => {
        this.swalUtil.popupMessage('Ocorreu algum erro ao salvar o relatório!','error');
        this.salvando = false;
      }
    })
  }

  updateReport()
  {
    this.salvando = true;
    this.inscricao = this.reportsService.update(this.formulario.value.id, this.formulario.value).subscribe({
      next: res => {
        this.swalUtil.popupMessage('Relatório atualizado com sucesso!', 'success');
        this.router.navigate(['/main/home']);
        this.salvando = false;
      },
      error: err => {
        this.swalUtil.popupMessage('Ocorreu algum erro ao atualizar o relatório!','error');
        this.salvando = false;
    }})
  }

  cancelReports() {
    this.swalUtil.popupMessage('O Relatório foi cancelado!', 'info');
    this.router.navigate(['main/home']);
    this.inscricao?.unsubscribe();
  }

  getServiceForecast(form) {
    this.formulario.patchValue({ ml_service_forecast: form });
  }

  sendForm()
  {
    this.formulario.value.id ? this.updateReport() : this.salvarReports()
  }

  filterScales() {
    if (this.formulario.value.paciente_id && this.formulario.value.mes && this.formulario.value.ano.length == 4) {
      this.loadingServiceDate = true;
      let array = {
        paciente_id: this.formulario.value.paciente_id.patient_id,
        ordemservico_id: this.formulario.value.ordemservico_id,
        contract_id: this.formulario.value.contract_id,
        month: this.formulario.value.mes,
        year: this.formulario.value.ano,
        servico_id: this.formulario.value.servico_id
      };
      this.inscricao = this.escalaService.getDaysOfScale(array).subscribe({
        next: res => {
          this.days = res;
          this.loadingServiceDate = false;
        },
        error: er => {
          this.loadingServiceDate = false;
        }
      })
    } else {
      this.swalUtil.info("É necessário preencher os campos: paciente, mês e ano.", 'Preencha os campos!')
    }
  }

  getServices(aux) {
    this.loadingServices = true;
    let array;
    this.services = [];
    if(aux.contract_id != null) {

      array = this.data.find(x => x.contract_id == aux.contract_id)

      // pegar os servicos dos pacotes
      if (array?.contract?.budget?.package_budget) {
        for (let j = 0; j < array.contract?.budget.package_budget.length; j++) {
          for (let i = 0; i < array.contract?.budget.package_budget[j].package.ml_packages_services.length; i++) {
            const element = array.contract?.budget.package_budget[j].package.ml_packages_services[i];
            this.services.push(
              element.servico.descricao + ': ' + (element.quantity ? element.quantity : '') + ' ' + (element.billing_basis ? element.billing_basis : '') + ' ' + (element.frequency ? element.frequency : '')
            );
          }
        }
      }

      // pegar os servicos dos pacotes personalizado
      if (array?.contract?.budget?.package_custom) {
        for (let j = 0; j < array.contract?.budget.package_custom.length; j++) {
          for (let i = 0; i < array.contract?.budget.package_custom[j].custom_service.length; i++) {
            const element = array.contract?.budget.package_custom[j].custom_service[i];
            this.services.push(
              element.servico.descricao + ': ' + (element.quantity ? element.quantity : '') + ' ' + (element.billing_basis ? element.billing_basis : '') + ' ' + (element.frequency ? element.frequency : '')
            );
          }
        }
      }

      // pegar os servicos avulsos
      if (array?.contract?.budget?.budget_service) {
        for (let j = 0; j < array.contract?.budget.budget_service.length; j++) {
          const element = array.contract?.budget.budget_service[j];
          this.services.push(
            element.servico.descricao + ': ' + (element.quantity ? element.quantity : '') + ' ' + (element.billing_basis ? element.billing_basis : '') + ' ' + (element.frequency ? element.frequency : '')
          );
        }
      }

      // pega os servicos do aditivo
      if (array?.contract?.additions) {
        for (let j = 0; j < array.contract?.additions.length; j++) {
          for (let i = 0; i < array.contract?.additions[j].ml_servicos.length; i++) {
            const element = array.contract?.additions[j].ml_servicos[i];
            this.services.push(
              element.servico.descricao + ': ' + (element.quantity ? element.quantity : '') + ' ' + (element.billing_basis ? element.billing_basis : '') + ' ' + (element.frequency ? element.frequency : '')
            );
          }
        }
      }
    }
    else {
      array = this.data.find(x => x.ordemservico_id == aux.ordemservico_id)

      if (array?.ordemservico?.orcamento?.servicos) {
        for (let index = 0;index < array.ordemservico?.orcamento.servicos.length;index++) {
          const element = array.ordemservico?.orcamento.servicos[index];
          this.services.push(
            element.descricao + ': ' + (element.quantidade ? element.quantidade : '') + ' ' + (element.basecobranca ? element.basecobranca : '') + ' ' + (element.frequencia ? element.frequencia : '')
          );
        }
      }
    }

    this.loadingServices = false;
  }

  //

  openModalSignature() {
      const dialogRef = this.dialog.open(ModalAssignatureComponent);

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.formulario.value.assinatura = result
        }
      });

  }

  ngOnDestroy() {
    if(this.inscricao) this.inscricao.unsubscribe();
  }
}
